<template>
    <div>
        <el-card class="box-card elCard">
            <!-- @click="changeHeight" -->
            <div slot="header" class="clearfix headerTitle">
                <span class="title">{{mTitle}}</span>
                <div class="titleRight">
                    <slot name="titleRight"></slot>
                </div>
            </div>
            <!-- <div v-show="max"> -->
            <slot name="content"></slot>
            <!-- </div> -->
        </el-card>
    </div>
</template>

<script>
export default {
    props: ['mTitle'],
    data() {
        return {
            max: true
        };
    },
    methods: {
        // changeHeight() {
        //     console.log('点击了头部');
        //     this.max = !this.max;
        // }
    }
};
</script>

<style  lang="less" scoped>
.elCard {
    font-size: 0.5rem;
    margin-bottom: 20px;
    .headerTitle {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title {
        }
    }
}
</style>